var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      key: `pda:${_vm.params.tab}:${_vm.params.section}`,
      attrs: { "data-intent": "pda-report" },
      on: {
        "chart-action": function($event) {
          return _vm.chartActionHandler($event)
        }
      }
    },
    [
      _c("header", { staticClass: "topbar bg-primary text-white" }, [
        _c(
          "section",
          { staticClass: "container-fluid position-relative h-100" },
          [
            _c("img", {
              staticClass: "h-100 img-fluid snap-left position-absolute",
              attrs: { src: "/assets/images/pda-dots-cropped.svg", alt: "" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "row align-items-end h-100 pb-2" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "h2",
                  {
                    staticClass: "text-white mb-0 ml-5 pl-4",
                    staticStyle: { "margin-left-ignore": "5rem" }
                  },
                  [
                    _vm._v("\n                            MarketSignals® "),
                    _c("span", { staticClass: "text-info" }, [
                      _vm._v("Prescriptive Data Analysis Report")
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ready,
                            expression: "ready"
                          },
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true }
                          }
                        ],
                        staticClass: "btn btn-sm btn-secondary ml-3",
                        attrs: { title: "Search", type: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.showDataElementSearch.apply(
                              null,
                              arguments
                            )
                          }
                        }
                      },
                      [
                        _c("FontAwesomeIcon", {
                          attrs: { "fixed-width": "", icon: ["fas", "search"] }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.headerExtra.length
                ? _c("div", {
                    staticClass: "col-lg-4 col-5 pr-xl-0",
                    domProps: { innerHTML: _vm._s(_vm.headerExtra) }
                  })
                : _vm._e()
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "position-fixed container-fluid p-0 mt-5",
          class: _vm.dataElementSearchClass,
          attrs: {
            "data-intent": "data-element-search",
            id: _vm.dataElementSearchContainerId
          }
        },
        [
          _c("div", { staticClass: "d-flex justify-content-end" }, [
            _c("div", { staticClass: "position-absolute w-50 m-2 shadow-lg" }, [
              _c(
                "form",
                {
                  staticClass: "bg-secondary p-2 rounded",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form-group row mb-0" }, [
                    _c(
                      "label",
                      {
                        staticClass: "col-auto col-form-label text-white pr-2",
                        attrs: { for: _vm.dataElementSearchInputId }
                      },
                      [
                        _c("FontAwesomeIcon", {
                          staticClass: "text-white",
                          attrs: {
                            "fixed-width": "",
                            icon: ["fas", "search"],
                            size: "lg"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col pl-0" }, [
                      _c("div", { staticClass: "input-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.dataElementSearchQuery,
                              expression: "dataElementSearchQuery"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: _vm.dataElementSearchInputId,
                            placeholder: _vm.dataElementSearchPlaceholderText,
                            type: "text"
                          },
                          domProps: { value: _vm.dataElementSearchQuery },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) return
                              _vm.dataElementSearchQuery = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true }
                              }
                            ],
                            staticClass: "btn btn-link",
                            attrs: {
                              type: "button",
                              "data-action": "clear-search",
                              title: "Clear search"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.clearDataElementSearch.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [
                            _c("FontAwesomeIcon", {
                              staticClass: "text-danger",
                              attrs: {
                                "fixed-width": "",
                                icon: ["fal", "times"],
                                size: "lg"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-auto pl-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link text-white text-uppercase",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.dataElementSearchVisible = false
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    Close\n                                "
                          )
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "bg-white",
                  attrs: { "data-intent": "data-element-search-results" }
                },
                [
                  _vm.dataElementSearchResultsBlock.length
                    ? _c(
                        "ul",
                        { staticClass: "list-group" },
                        [
                          _c("li", { staticClass: "list-group-item" }, [
                            _c(
                              "div",
                              { staticClass: "row align-items-center" },
                              [
                                _c("div", { staticClass: "col h4 mb-0" }, [
                                  _vm._v("Search Results")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-auto" },
                                  [
                                    _c(
                                      "RouterLink",
                                      {
                                        attrs: {
                                          to: {
                                            params: {
                                              tab: "data-guide",
                                              section: null
                                            },
                                            query: {
                                              search: _vm.dataElementSearchQuery
                                            }
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                            Show All\n                                        "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.dataElementSearchResultsBlock, function(
                            result
                          ) {
                            return _vm.dataElementSearchLink(result)
                              ? _c(
                                  "RouterLink",
                                  {
                                    key: result.dataElement.dataElementId,
                                    staticClass: "list-group-item",
                                    attrs: {
                                      to: _vm.dataElementSearchLink(result)
                                        .route
                                    }
                                  },
                                  [
                                    _c("strong", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          result.dataElement.shortDescription
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "small",
                                      { staticClass: "text-nowrap" },
                                      [
                                        _vm._v("— "),
                                        _c("em", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.dataElementSearchLink(result)
                                                .pageDescription
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    : _vm.isVisibleDataElementSearchNoResults
                    ? _c("div", { staticClass: "alert alert-warning m-3" }, [
                        _vm._v(
                          '\n                            No elements matching "' +
                            _vm._s(_vm.dataElementSearchQuery) +
                            '"\n                        '
                        )
                      ])
                    : _vm._e()
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      !_vm.printMode && _vm.pageReady && _vm.ready
        ? _c("subnav", {
            key: _vm.subnavTimestamp,
            attrs: { "nav-links": _vm.subnavLinks, placement: "page" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("article", { staticClass: "container-fluid p-3 pt-0 bg-white" }, [
        _c("section", { staticClass: "bg-white" }, [
          _c(
            "div",
            { staticClass: "container-fluid p-0" },
            [
              _vm.error.code
                ? _c("div", {
                    staticClass: "p-5 text-center",
                    domProps: { innerHTML: _vm._s(_vm.error.message) }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.ready && _vm.reportDataReady
                ? _c("div", { staticClass: "report-container" }, [
                    _c("div", { staticClass: "report-section bg-white" }, [
                      _vm.reportReady
                        ? _c("section", [
                            !_vm.customLayout
                              ? _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col" }, [
                                    !_vm.printMode && _vm.sectionTitle
                                      ? _c("h1", { staticClass: "h3 mb-3" }, [
                                          _vm.hasPageLevelCartExport
                                            ? _c("a", {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover.top",
                                                    modifiers: {
                                                      hover: true,
                                                      top: true
                                                    }
                                                  }
                                                ],
                                                attrs: {
                                                  href: "",
                                                  title: _vm.associatedDataTableActionParameters(
                                                    _vm.pageLevelDataElementIds
                                                  ).tooltip
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm
                                                      .associatedDataTableActionParameters(
                                                        _vm.pageLevelDataElementIds
                                                      )
                                                      .html.replace("fa-lg", "")
                                                  )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.pageLevelCartExport.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  }
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(_vm.sectionTitle) +
                                              "\n                                                "
                                          ),
                                          _vm.onPageHelpContent
                                            ? _c(
                                                "a",
                                                [
                                                  _c("on-page-help", {
                                                    attrs: {
                                                      "help-content":
                                                        _vm.onPageHelpContent
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _vm.filterStatusMessage
                                    ? _c("div", { staticClass: "col" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "mb-0",
                                            class: _vm.filterAlertClass
                                          },
                                          [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.filterStatusMessage
                                                )
                                              }
                                            }),
                                            _vm._v(
                                              "\n                                                Adjust this in "
                                            ),
                                            _c(
                                              "RouterLink",
                                              {
                                                staticClass: "alert-link",
                                                attrs: {
                                                  to: {
                                                    params: {
                                                      tab: "settings",
                                                      section: null
                                                    }
                                                  }
                                                }
                                              },
                                              [_vm._v("Settings")]
                                            ),
                                            _vm._v(
                                              ".\n                                            "
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.allowExcelExport
                                    ? _c(
                                        "div",
                                        { staticClass: "col text-right" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip:hover",
                                                  value: `Download page in Excel format`,
                                                  expression:
                                                    "`Download page in Excel format`",
                                                  arg: "hover"
                                                }
                                              ],
                                              staticClass: "btn btn-success",
                                              attrs: { href: "" },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.excelExport.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: ["fas", "file-excel"]
                                                }
                                              }),
                                              _vm._v(
                                                "\n                                                Download\n                                            "
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column-reverse" },
                              [
                                _vm.customLayout
                                  ? _c(
                                      "section",
                                      {
                                        attrs: {
                                          "data-intent": "custom-layout"
                                        }
                                      },
                                      [
                                        _c(_vm.customLayout.component, {
                                          tag: "component",
                                          attrs: {
                                            "chart-data":
                                              _vm.customLayout.chartData,
                                            detail:
                                              _vm.customLayout.detail || {},
                                            params:
                                              _vm.customLayout.params || {},
                                            "report-ready": _vm.reportReady
                                          },
                                          on: {
                                            "change-setting": _vm.changeSetting,
                                            "delete-all-cart-items":
                                              _vm.deleteAllCartItems,
                                            "delete-cart-item":
                                              _vm.deleteCartItem,
                                            "handle-cart-item":
                                              _vm.handleCartItem,
                                            "prepare-for-order":
                                              _vm.prepareForOrder,
                                            "set-sort-group": function($event) {
                                              _vm.sortGroup = $event
                                            },
                                            "set-data-element-list": function(
                                              $event
                                            ) {
                                              _vm.customDataElementList = $event
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              _vm.customLayout.afterChart
                                                ? {
                                                    key: "afterChart",
                                                    fn: function() {
                                                      return [
                                                        _c("div", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.customLayout
                                                                .afterChart
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                : null
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  : _c(
                                      "section",
                                      {
                                        attrs: {
                                          "data-intent": "chart-grid-section"
                                        }
                                      },
                                      [
                                        _vm.chartListData.length
                                          ? _c("chart-grid", {
                                              key: _vm.sectionKey,
                                              attrs: {
                                                "chart-wrapper-class": {
                                                  "offset-lg-3":
                                                    _vm.layoutColumns === 1,
                                                  "col-lg-6":
                                                    _vm.layoutColumns > 0,
                                                  col: _vm.layoutColumns < 0
                                                },
                                                charts: _vm.chartListData,
                                                "charts-associated-data":
                                                  _vm.chartListAssociatedData
                                              },
                                              on: {
                                                "associated-data-table-action":
                                                  _vm.associatedDataTableActionHandler
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.showPagination
                                          ? _c(
                                              "div",
                                              { staticClass: "text-right" },
                                              [
                                                _c("pagination", {
                                                  staticClass:
                                                    "m-auto justify-content-end",
                                                  attrs: {
                                                    "current-page":
                                                      _vm.pagination
                                                        .currentPage,
                                                    "item-count":
                                                      _vm.pagination.itemCount,
                                                    "items-per-page":
                                                      _vm.pagination
                                                        .itemsPerPage
                                                  },
                                                  on: {
                                                    "pagination:click":
                                                      _vm.paginateTo,
                                                    "pagination:page-size":
                                                      _vm.paginationSize
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                _vm._v(" "),
                                _c("div", { staticClass: "row mt-3" }, [
                                  _vm.sortGroupOptions.length
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "sort-options text-center col"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "btn-group select-group d-flex",
                                              attrs: { role: "group" }
                                            },
                                            [
                                              _vm._l(
                                                _vm.sortGroupOptions,
                                                function(button) {
                                                  return [
                                                    button.hasOwnProperty(
                                                      "group"
                                                    )
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn media-body w-100",
                                                            class: [
                                                              `select-${button.color}`,
                                                              {
                                                                active:
                                                                  _vm.sortGroup ===
                                                                  button.group
                                                              }
                                                            ],
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.sortGroup =
                                                                  button.group
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                            " +
                                                                _vm._s(
                                                                  button.label
                                                                ) +
                                                                "\n                                                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    button.hasOwnProperty(
                                                      "items"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "btn-group dropdown-bubble",
                                                            attrs: {
                                                              role: "group"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "btn dropdown-toggle media-body",
                                                                class: `select-${button.color}`,
                                                                attrs: {
                                                                  "aria-haspopup":
                                                                    "true",
                                                                  "aria-expanded":
                                                                    "false",
                                                                  "data-toggle":
                                                                    "dropdown",
                                                                  id: button.id
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                                " +
                                                                    _vm._s(
                                                                      button.label
                                                                    ) +
                                                                    "\n                                                            "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "dropdown-menu",
                                                                attrs: {
                                                                  "aria-labelledby":
                                                                    button.id
                                                                }
                                                              },
                                                              _vm._l(
                                                                button.items,
                                                                function(item) {
                                                                  return _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "dropdown-item",
                                                                      attrs: {
                                                                        href: ""
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          return item.callback.apply(
                                                                            null,
                                                                            arguments
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.label
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showPagination
                                    ? _c(
                                        "div",
                                        { staticClass: "col-auto" },
                                        [
                                          _c("pagination", {
                                            staticClass:
                                              "m-auto justify-content-end",
                                            attrs: {
                                              "current-page":
                                                _vm.pagination.currentPage,
                                              "item-count":
                                                _vm.pagination.itemCount,
                                              "items-per-page":
                                                _vm.pagination.itemsPerPage
                                            },
                                            on: {
                                              "pagination:click":
                                                _vm.paginateTo,
                                              "pagination:page-set":
                                                _vm.paginationSet,
                                              "pagination:page-size":
                                                _vm.paginationSize
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          ])
                        : _c(
                            "section",
                            [_c("spinner", { attrs: { text: "Building..." } })],
                            1
                          )
                    ])
                  ])
                : _vm.error.code === 0
                ? _c("spinner", { staticClass: "text-secondary" })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.ready
        ? _c(
            "b-modal",
            {
              attrs: {
                "hide-footer": "",
                id: _vm.debugDataElementSearchModal,
                size: "lg"
              },
              on: { hidden: _vm.resetdebugDataElementSearch },
              scopedSlots: _vm._u(
                [
                  {
                    key: "modal-header",
                    fn: function({ hide }) {
                      return [
                        _c("h3", [_vm._v("Data Element Search")]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "b-toggle",
                                rawName: "v-b-toggle.hover",
                                modifiers: { hover: true }
                              }
                            ],
                            attrs: { title: "Close" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return hide()
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { size: "2x", icon: ["far", "times"] }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                2762839379
              )
            },
            [
              _vm._v(" "),
              _c(
                "b-form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.getdebugDataElementSearchResults.apply(
                        null,
                        arguments
                      )
                    }
                  }
                },
                [
                  _c(
                    "b-input-group",
                    {
                      class: {
                        "mb-3": _vm.debugDataElementSearchResult.length > 0
                      }
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "form-control",
                        attrs: {
                          autofocus: "",
                          id: "debugDataElementSearchQuery",
                          placeholder: "Search for a data element here",
                          required: true
                        },
                        model: {
                          value: _vm.debugDataElementSearchQuery,
                          callback: function($$v) {
                            _vm.debugDataElementSearchQuery = $$v
                          },
                          expression: "debugDataElementSearchQuery"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            { attrs: { type: "submit", variant: "info" } },
                            [_vm._v("Search")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.debugDataElementSearchResult.length
                ? _c("section", [
                    _c("div", { staticClass: "alert alert-info" }, [
                      _vm._v(
                        "Showing " +
                          _vm._s(
                            Math.min(
                              10,
                              _vm.debugDataElementSearchResult.length
                            )
                          ) +
                          " of " +
                          _vm._s(_vm.debugDataElementSearchResult.length) +
                          " results"
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "accordion", attrs: { role: "tablist" } },
                      [
                        _vm._l(_vm.debugDataElementSearchResult, function(
                          result,
                          index
                        ) {
                          return [
                            index < 10
                              ? _c(
                                  "b-card",
                                  { attrs: { "no-body": "" } },
                                  [
                                    _c(
                                      "b-card-header",
                                      {
                                        staticClass: "p-0",
                                        attrs: {
                                          "header-tag": "header",
                                          role: "tab"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-toggle",
                                                rawName: "v-b-toggle",
                                                value: `accordion-${index}`,
                                                expression:
                                                  "`accordion-${index}`"
                                              }
                                            ],
                                            staticClass: "text-left",
                                            attrs: {
                                              block: "",
                                              variant: "info"
                                            }
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  result.dataElement
                                                    .dataElementId
                                                )
                                              )
                                            ]),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  result.dataElement
                                                    .shortDescription
                                                ) +
                                                "\n                                    "
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "float-right badge badge-light ml-3"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.pages.length) +
                                                    " pages"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-collapse",
                                      {
                                        attrs: {
                                          accordion: "my-accordion",
                                          id: `accordion-${index}`,
                                          role: "tabpanel",
                                          visible: index === 0
                                        }
                                      },
                                      [
                                        _c(
                                          "b-card-body",
                                          { staticClass: "p-0" },
                                          [
                                            result.pages.length
                                              ? _c(
                                                  "div",
                                                  { staticClass: "p-3" },
                                                  [
                                                    _c("em", [
                                                      _vm._v(
                                                        "Found on the following pages:"
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "ul",
                                                      { staticClass: "m-0" },
                                                      _vm._l(
                                                        result.pages,
                                                        function(page) {
                                                          return _c(
                                                            "li",
                                                            [
                                                              _c(
                                                                "RouterLink",
                                                                {
                                                                  attrs: {
                                                                    to:
                                                                      page.route
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                    " +
                                                                      _vm._s(
                                                                        page.pageDescription
                                                                      ) +
                                                                      " > " +
                                                                      _vm._s(
                                                                        page.categoryDescription
                                                                      ) +
                                                                      "\n                                                "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("pre", {
                                              staticClass:
                                                "text-size-md bg-dark text-white m-0",
                                              staticStyle: {
                                                "white-space": "pre-wrap"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  result.dataElement
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }